export default __webpack_public_path__ + "static/media/search-result-play.dd9b4d27.svg";